import { atom } from 'jotai/index';

import type { IGoal, IGoalGroup } from '../types/Goal';

export const membershipGoalsAtom = atom<IGoalGroup[] | null>(null);
export const selectedGoalAtom = atom<IGoal | null>(null);
export const fireGoalConfettiCannonAtom = atom<boolean>(false);
export const goalsExplanationSimpleModalIsOpenAtom = atom<boolean>(false);
